import styled from "styled-components";
import { TextField as MuiTextField, Select as MuiSelect } from "@mui/material";
import exp from "node:constants";

export const Container = styled.div<{ $isFocused: boolean }>`
  display: flex;
  width: 100%;
  justify-content: ${({ $isFocused }) => ($isFocused ? "space-between;" : "none")};
  align-items: center;
  margin-bottom: 8px;
`;

export const AddableSectionMark = styled.div`
    position: absolute;
    right: 10px;
    bottom: 10px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.BLUE_HEAVY};
    margin: "20px 0 -40px -20px";
`;

export const TextField = styled(MuiTextField)<{
  $isTitle: boolean;
  $isFocused: boolean;
  $isSection: boolean;
  $autoWidth: number;
  alert: boolean;
}>`
  width: ${({ $isTitle, $isFocused, $autoWidth, $isSection }) => {
    if ($isFocused) {
      return $isTitle ? "100%" : "492px";
    }
    if ($isTitle || $isSection) {
      return "60%";
    }
    return $autoWidth ? `${$autoWidth}px` : "100%";
  }};
  margin: ${({ $isSection, $isFocused }) =>
    $isSection && !$isFocused ? "20px 0 -40px -20px" : "0"};

  padding: 8px 0;
  div {
    border: ${({ alert }) => (alert ? `1px solid red` : `none`)};
    font-weight: ${({ $isFocused }) => ($isFocused ? "normal" : "bold")};
    font-size: ${({ $isTitle, $isSection }) => ($isTitle || $isSection ? "28px" : "18px")};
    padding: ${({ $isTitle, $isFocused }) => {
      if ($isFocused) {
        return $isTitle ? 0 : "16px";
      }
      return 0;
    }};
    background-color: ${({ $isTitle, $isFocused, theme }) => {
      if ($isFocused) {
        return $isTitle ? "transparent" : theme.colors.GREY_LIGHT;
      }
      return "transparent";
    }};

    ::before {
      border-bottom: ${({ $isFocused, theme }) =>
        $isFocused ? `1px solid ${theme.colors.GREY_HEAVY}` : "none"};
    }

    ::after {
      border-bottom: ${({ theme }) => `2px solid ${theme.colors.BLUE_HEAVY}`};
    }
  }

  input {
    padding: 0;
  }
`;

export const Select = styled(MuiSelect)`
  width: 208px;
  height: 48px;
  fieldset {
    border-color: ${({ theme }) => theme.colors.GREY_HEAVY} !important;
    border-width: 1px !important;
  }
`;

export const RequireMark = styled.span`
  padding-left: 4px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.RED};
`;
